import { render, staticRenderFns } from "./OverviewProvider.vue?vue&type=template&id=cf379466"
import script from "./OverviewProvider.vue?vue&type=script&lang=js"
export * from "./OverviewProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports